module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"zoom_level":"Zoom level:"},"fr":{"zoom_level":"Niveau de zoom :"}}')
  delete Component.options._Ctor
}
